module.exports = __webpack_public_path__ + "static/media/google-meet.12dd4b2e.svg";